import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import CommonPage from "@icarius-common/commonPage";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { Typography, TextField, Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { createTypeOfSkillsAction, updateTypeOfSkillsAction } from "../../actions";
import useHandleForm from "./useHandleForm";
import CustomNumberFormat from "@icarius-common/dynamicInputs/customNumberFormat";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";
import { getAppColor } from "@icarius-app/selectors";

const gridStyle = { height: 75, padding: "0px 10px" };

const Form = (props) => {
    const { isLoading, data, handleClose, showVerificationMessage, showWeightSpecificSkills, skillClassList } = props;

    const dispatch = useDispatch();

    const color = useSelector(getAppColor);

    const goBackItem = () => (
        <CustomIconButton title={getLocalizedString("goBack")} onClick={handleClose} type={"goBack"} />
    );

    const create = (formData) => {
        dispatch(createTypeOfSkillsAction(formData)).then((res) => {
            if (res?.status === 200) {
                showVerificationMessage(res.data.verificationFailures);
                handleClose();
            }
        });
    };

    const modify = (formData) => {
        dispatch(updateTypeOfSkillsAction(formData)).then((res) => {
            if (res?.status === 200) {
                showVerificationMessage(res.data.verificationFailures);
                handleClose();
            }
        });
    };

    const openValidationError = () => {
        dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
    };

    const { isCreate, formData, setFormValue, submit } = useHandleForm(
        data,
        showWeightSpecificSkills,
        create,
        modify,
        openValidationError
    );

    return (
        <CommonPage
            isLoading={isLoading}
            title={`${isCreate ? getLocalizedString("create") : getLocalizedString("editRequest")} competencia`}
            menuItems={[goBackItem]}
            isNotGridPage
        >
            <Grid container item xs={12} direction="row" style={{ width: "95%", margin: "auto" }}>
                <Grid container item xs={12}>
                    <Grid container item alignItems="center" xs={12} md={3} style={gridStyle}>
                        <TextField
                            required
                            fullWidth
                            margin={"none"}
                            label={getLocalizedString("competencyName")}
                            value={formData.name}
                            onChange={(e) => setFormValue(e.target.value, "name")}
                            inputProps={{ maxLength: 60 }}
                        />
                    </Grid>
                    <Grid container item alignItems="center" xs={12} md={3} style={gridStyle}>
                        <TextField
                            required
                            fullWidth
                            margin={"none"}
                            label={getLocalizedString("competencyGroup")}
                            value={formData.group}
                            onChange={(e) => setFormValue(e.target.value, "group")}
                            inputProps={{ maxLength: 40 }}
                        />
                    </Grid>
                    <Grid container item alignItems="center" xs={12} md={3} style={gridStyle}>
                        <FormControl style={{ width: "100%" }}>
                            <InputLabel required id={`label`}>
                                {getLocalizedString("skillClass")}
                            </InputLabel>
                            <Select
                                value={formData.skillClass}
                                labelId={`label`}
                                id={`select`}
                                onChange={(e) => setFormValue(e.target.value, "skillClass")}
                                margin={"none"}
                            >
                                {skillClassList.map((item) => (
                                    <MenuItem className={"whiteText"} key={item.key} value={item.key}>
                                        {item.value}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    {showWeightSpecificSkills && (
                        <Grid container item alignItems="center" xs={12} md={3} style={gridStyle}>
                            <TextField
                                required
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("competencyWeight")}
                                value={formData.weighted}
                                onChange={(e) => setFormValue(e.target.value, "weighted")}
                                InputProps={{ inputComponent: CustomNumberFormat }}
                                inputProps={{ min: "1", step: "0.1", decimals: 2 }}
                                helperText={getLocalizedString("valueBetween0And100")}
                                style={{ marginTop: 14 }}
                            />
                        </Grid>
                    )}
                    <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px 0px 10px" }}>
                        <TextFieldMultiline
                            required
                            fullWidth
                            label={getLocalizedString("description")}
                            rows={10}
                            margin={"none"}
                            value={formData.description}
                            onChange={(e) => setFormValue(e.target.value, "description")}
                            inputProps={{ spellCheck: "false" }}
                        />
                    </Grid>
                    <Grid container item alignItems="center" xs={12} style={gridStyle}>
                        <Typography type="caption" style={{ fontWeight: 600, color: color }}>
                            {getLocalizedString("createSpecificCompetencyWarning")}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12} justify={"flex-end"} alignItems="center" style={{ marginBottom: 35 }}>
                    <ButtonDialogAction isAccept onClick={submit} text={getLocalizedString("save")} />
                </Grid>
            </Grid>
        </CommonPage>
    );
};

export default Form;
